import { render, staticRenderFns } from "./MySchoolList.vue?vue&type=template&id=c649b286&"
import script from "./MySchoolList.vue?vue&type=script&lang=js&"
export * from "./MySchoolList.vue?vue&type=script&lang=js&"
import style0 from "./MySchoolList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports